(function ($, Drupal) {
	'use strict'

	Drupal.behaviors.anchor = {
		attach: function (context, settings) {
			$('.field-anchor-items a').click(function(){

				$(this).addClass('active');
				if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

					if (target.length) {
					  event.preventDefault();
					  $('html, body').animate({
						scrollTop: target.offset().top - 90
					  }, 1000);
					}
				}
			});
		}
	}

}) (jQuery, Drupal)